import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './booking.reducer';

export const BookingDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bookingEntity = useAppSelector(state => state.booking.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bookingDetailsHeading">
          <Translate contentKey="activitiesApp.booking.detail.title">Booking</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{bookingEntity.id}</dd>
          <dt>
            <span id="adultCount">
              <Translate contentKey="activitiesApp.booking.adultCount">Adult Count</Translate>
            </span>
          </dt>
          <dd>{bookingEntity.adultCount}</dd>
          <dt>
            <span id="childCount">
              <Translate contentKey="activitiesApp.booking.childCount">Child Count</Translate>
            </span>
          </dt>
          <dd>{bookingEntity.childCount}</dd>
          <dt>
            <span id="infantCount">
              <Translate contentKey="activitiesApp.booking.infantCount">Infant Count</Translate>
            </span>
          </dt>
          <dd>{bookingEntity.infantCount}</dd>
          <dt>
            <span id="bookingDate">
              <Translate contentKey="activitiesApp.booking.bookingDate">Booking Date</Translate>
            </span>
          </dt>
          <dd>
            {bookingEntity.bookingDate ? <TextFormat value={bookingEntity.bookingDate} type="date" format={APP_LOCAL_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="totalPrice">
              <Translate contentKey="activitiesApp.booking.totalPrice">Total Price</Translate>
            </span>
          </dt>
          <dd>{bookingEntity.totalPrice}</dd>
          <dt>
            <span id="bookingStatus">
              <Translate contentKey="activitiesApp.booking.bookingStatus">Booking Status</Translate>
            </span>
          </dt>
          <dd>{bookingEntity.bookingStatus}</dd>
          <dt>
            <span id="reviewRequestEmailCount">
              <Translate contentKey="activitiesApp.booking.reviewRequestEmailCount">Review Request Email Count</Translate>
            </span>
          </dt>
          <dd>{bookingEntity.reviewRequestEmailCount}</dd>
          <dt>
            <Translate contentKey="activitiesApp.booking.bookingUser">Booking User</Translate>
          </dt>
          <dd>{bookingEntity.bookingUser ? bookingEntity.bookingUser.firsName : ''}</dd>
          <dt>
            <Translate contentKey="activitiesApp.booking.activity">Activity</Translate>
          </dt>
          <dd>{bookingEntity.activity ? bookingEntity.activity.name : ''}</dd>
          <dt>
            <Translate contentKey="activitiesApp.booking.user">User</Translate>
          </dt>
          <dt>
            <span id="createdDate">
              <Translate contentKey="activitiesApp.booking.createdDate">Created Date</Translate>
            </span>
          </dt>
          <dd>
            {bookingEntity.createdDate ? <TextFormat value={bookingEntity.createdDate} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="modifiedDate">
              <Translate contentKey="activitiesApp.booking.modifiedDate">Modified Date</Translate>
            </span>
          </dt>
          <dd>
            {bookingEntity.modifiedDate ? <TextFormat value={bookingEntity.modifiedDate} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dd>{bookingEntity.user ? bookingEntity.user.login : ''}</dd>
          <dt>
            <Translate contentKey="activitiesApp.booking.weekDayTime">Week Day Time</Translate>
          </dt>
          <dd>{bookingEntity.weekDayTime ? bookingEntity.weekDayTime.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/booking" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/booking/${bookingEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BookingDetail;
